import { useCallback, useEffect, useRef, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';

interface UseTableHeightProps {
  marginHeight?: number;
}

export const useTableHeight = ({ marginHeight = 100 }: UseTableHeightProps) => {
  const refContainer = useRef<HTMLDivElement>(null);
  const [listHeight, setListHeight] = useState(0);

  const calculateHeight = useCallback(() => {
    if (refContainer.current) {
      const h = refContainer.current.getBoundingClientRect().height;
      setListHeight(h - marginHeight);
    }
  }, [marginHeight]);

  const debouncedCalculate = useDebouncedCallback(calculateHeight, 16);

  useEffect(() => {
    calculateHeight();
    const observer = new ResizeObserver(debouncedCalculate);
    if (refContainer.current) observer.observe(refContainer.current);
    return () => observer.disconnect();
  }, [calculateHeight, debouncedCalculate]);

  return { refContainer, listHeight };
};
